var render = function render(){
  var _vm$estimatedDti, _vm$estimatedDti2, _vm$estimatedDti2$ext, _vm$income;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "header-block"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Orientačný limit úveru podľa DTI")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti = _vm.estimatedDti) === null || _vm$estimatedDti === void 0 ? void 0 : _vm$estimatedDti.value)) + " EUR")])], 1)]), _c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_vm._v("Akceptovaný príjem / mes.")]), _c('div', [_vm.dtiLoading ? _c('v-progress-circular', {
    staticClass: "loading-spinner extrasmall",
    attrs: {
      "indeterminate": ""
    }
  }) : _c('div', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("dotTheAmount")((_vm$estimatedDti2 = _vm.estimatedDti) === null || _vm$estimatedDti2 === void 0 ? void 0 : (_vm$estimatedDti2$ext = _vm$estimatedDti2.extra) === null || _vm$estimatedDti2$ext === void 0 ? void 0 : _vm$estimatedDti2$ext.prijem_mo)) + " EUR")])], 1)]), (_vm$income = _vm.income) !== null && _vm$income !== void 0 && _vm$income.error ? _c('div', [_c('br'), _vm._l(_vm.income.error, function (error, key) {
    return _c('div', {
      key: key,
      staticClass: "error-text"
    }, [_vm._v(" " + _vm._s(error) + " ")]);
  })], 2) : _vm._e(), _vm.previewError ? _c('div', {
    staticClass: "error-text",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v(_vm._s(_vm.previewError))]) : _vm._e(), _vm._l(_vm.rentalWarnings, function (warning) {
    return _c('div', {
      key: warning.code,
      staticClass: "error-text rental-bank-warning"
    }, [_c('strong', [_vm._v(_vm._s(warning.name) + ":")]), _vm._v(" " + _vm._s(warning.message) + " ")]);
  })], 2), _c('form', {
    attrs: {
      "id": "income-submit"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveIncome.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "income-methodology-note"
  }, [_vm._v(" Príjem z prenájmu sa uloží ako doplnkový príjem. Zadajte mesačné nájomné, odkedy ho klient poberá a či už bol príjem zdanený. Každá banka následne akceptuje jeho výšku podľa vlastnej metodiky. ")]), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.form.suma,
      expression: "form.suma",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "text-input w-input required",
    attrs: {
      "type": "number",
      "step": "0.01",
      "maxlength": "256",
      "name": "najomne",
      "data-name": "najomne",
      "placeholder": "",
      "id": "najomne",
      "required": ""
    },
    domProps: {
      "value": _vm.form.suma
    },
    on: {
      "change": _vm.showEstimatedDtiToUser,
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.form, "suma", _vm._n($event.target.value));
      },
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "prijem-od"
    }
  }, [_vm._v("Neprerušený príjem nájmu od")]), _c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "attach": "",
      "offset-y": "",
      "max-width": "290",
      "min-width": "290"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('button', _vm._g(_vm._b({
          ref: "monthPickerButton",
          staticClass: "text-input w-input rental-month-button",
          attrs: {
            "id": "prijem-od",
            "type": "button",
            "aria-invalid": _vm.monthError ? 'true' : 'false',
            "aria-describedby": "prijem-od-help"
          }
        }, 'button', attrs, false), on), [_c('span', [_vm._v(_vm._s(_vm.formattedRentalMonth || 'Vyberte mesiac a rok'))]), _c('svg', {
          attrs: {
            "width": "22",
            "height": "22",
            "viewBox": "0 0 24 24",
            "fill": "none",
            "stroke": "currentColor",
            "stroke-width": "1.8",
            "aria-hidden": "true"
          }
        }, [_c('rect', {
          attrs: {
            "x": "3",
            "y": "5",
            "width": "18",
            "height": "16",
            "rx": "2"
          }
        }), _c('path', {
          attrs: {
            "d": "M16 3v4M8 3v4M3 11h18"
          }
        })])])];
      }
    }]),
    model: {
      value: _vm.monthPickerOpen,
      callback: function callback($$v) {
        _vm.monthPickerOpen = $$v;
      },
      expression: "monthPickerOpen"
    }
  }, [_c('v-date-picker', {
    attrs: {
      "value": _vm.form.prijem_od,
      "type": "month",
      "locale": "sk-SK",
      "max": _vm.getTodayDate(),
      "min": '0001-01',
      "no-title": ""
    },
    on: {
      "input": _vm.selectRentalMonth
    }
  })], 1), _c('p', {
    staticClass: "rental-month-help",
    "class": {
      'error-text': _vm.monthError
    },
    attrs: {
      "id": "prijem-od-help",
      "role": _vm.monthError ? 'alert' : null
    }
  }, [_vm._v(" " + _vm._s(_vm.monthError || 'Vyberte mesiac a rok, odkedy klient nepretržite poberá nájomné.') + " ")])], 1), _c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'rental_prijem_zdaneny',
      "init-value": _vm.form.prijem_zdaneny,
      "options": _vm.taxedChoices,
      "normal": "",
      "name": 'Bol príjem už zdanený?',
      "required": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event, 'prijem_zdaneny');
      }
    }
  })], 1)])]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "najomne"
    }
  }, [_vm._v("Výška mesačného nájomného"), _c('strong')]);

}]

export { render, staticRenderFns }